import { render } from "./notification.vue?vue&type=template&id=5d9ef1f2&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./notification.vue?vue&type=style&index=0&id=5d9ef1f2&lang=scss&module=true"
cssModules["$style"] = style0
import "./notification.vue?vue&type=style&index=1&id=5d9ef1f2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-5d9ef1f2"]])

export default __exports__